import React from 'react'
import { useForm } from 'react-hook-form'
import { Button, Flex, Icon, Input, InputGroup, InputLeftAddon, Select } from '@chakra-ui/react'
import { FaSearch } from 'react-icons/fa'
import { useControleIlustracaoContext } from '../../../contexts/ControleIlustracaoProvider'
import { ModalCompreGanhe } from './ModalCompreGanhe'

export const FiltroControleIlustracao = () => {
  const form = useForm()

  const { query, setFormValues, cancelCompreGanhe } = useControleIlustracaoContext()

  const { register, handleSubmit } = form

  const { isLoading, isRefetching, data } = query

  async function handleSubmitFilter(data) {
    cancelCompreGanhe()

    const { pedido } = data

    setFormValues({ pedido })
  }

  function onCompreGanhe(compreGanhe = 1) {
    setFormValues({ compre_ganhe: compreGanhe })
  }

  return (
    <Flex as="form" alignItems="flex-end" gap={5} w="full" maxW="826px" mx="auto" onSubmit={handleSubmit(handleSubmitFilter)}>
      <InputGroup size="sm">
        <InputLeftAddon children="Pesquisar pedido" as="label" htmlFor="pedido" />
        <Input id="pedido" type={'pedido'} placeholder={'Pedido'} {...register('pedido')} />
      </InputGroup>

      <Button
        fontSize="12px"
        fontWeight="normal"
        size="sm"
        maxW="147px"
        bgColor="#378BBF"
        w="100%"
        type="submit"
        colorScheme="blue"
        leftIcon={<Icon as={FaSearch} />}
        isLoading={isLoading || isRefetching}
      >
        Filtrar
      </Button>
      <ModalCompreGanhe onCompreGanhe={onCompreGanhe} />
    </Flex>
  )
}
